<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h4 class="mt-4 mb-3">Lista de grupos de formas</h4>
        <EditImgFormFamily v-show="showEditImgFormFamily" :getImgFormFamilyId="imgFormFamilyId"
            @hideEditFormFamily="hideEditImgForm">
        </EditImgFormFamily>
        <div class="row">
            <div class="col-sm-2">
                <SearchByFamily @showFamiliesByFilter="getFamiliesByFilter"></SearchByFamily>
            </div>
            <div class="col-sm-10">
                <ListImgFormFamilies @sendImgFormFamilyId="setImgFormFamilyId"
                    :sendFamiliesByFilter="imgFormFamiliesByFilter">
                </ListImgFormFamilies>
            </div>
        </div>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import ListImgFormFamilies from "@/components/Admin/Families/ListImgFormFamiliesAdminComponent.vue"
import EditImgFormFamily from "@/components/Admin/Families/EditImgFormFamilyAdminComponent.vue"
import SearchByFamily from "@/components/Admin/Families/SearchImgFormFamilyTypeAdminComponent.vue";
export default {
    name: "Home Admin",
    components: {
        NavBarAdmin,
        FooterAdmin,
        ListImgFormFamilies,
        EditImgFormFamily,
        SearchByFamily,
    },
    data() {
        return {
            showCreateImgFormFamily: false,
            imgFormFamilyId: null,
            showEditImgFormFamily: false,
            imgFormFamiliesByFilter: [],
        }
    },
    methods: {
        setImgFormFamilyId(data) {
            this.imgFormFamilyId = data.imgFormId;
            //console.log(this.imgFormFamilyId);
            this.imgFormFamilyId != null ? this.showEditImgFormFamily = data.showEdit : this.showEditImgFormFamily;
        },
        hideEditImgForm() {
            this.imgFormFamilyId = null;
            this.showEditImgFormFamily = false;
        },
        getFamiliesByFilter(data) {
            this.imgFormFamiliesByFilter = data;
            //console.log(this.imgFormFamilies);
        }
    },
}
</script>